import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from './Calendario.module.css'
import Dia from './Dia';

function SemanaComponent(props) {

    const generarDiasDeLaSemana = empieza => {
        let content = [];
        for (let i = 1; i < 8; i++) {
            //for dentro de otro for
            if (i === empieza) {
                console.log('Estoy en la posición:' + i)
                content.push(<div className={`col-md-1 ${estilos.col_md_1especial}`}><Dia></Dia></div>);
            }
            else {
                console.log('Estoy en la posición:' + i)
                content.push(<div className={`col-md-1 ${estilos.col_md_1especial}`}><Dia></Dia></div>);
            }
        }
        console.log('Salí del for')
        return content;
    };
    return (
        <Fragment>
            {
                generarDiasDeLaSemana(props.empieza)
            }
        </Fragment>
    );
};


export default withRouter(SemanaComponent)
